module.exports = __webpack_public_path__ + "img/bg-cant-find_small@2x.8414998c.webp";